export default __webpack_public_path__ + "static/media/apot-menu.02cbc3f8.png";